import React, { useEffect, useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "../../../utils/constants";
import { ISearchPage } from "../../../types/FmsTypes";
import { transPgToPagination } from "../../base/app/appModel";
import { IBillDetail, IBIllFields, IBillSearch, IBillSearchParam, IBillSummary } from "../../bill/BillTypes";
import { billService } from "../../bill/BillService";
import { UserTypeEnum } from "../../../types/FmsEnums";
import { ITreeData } from "../../base/dict/dictModel";
import { IMdOrgDetail, orgService } from "../../base/org/orgService";
import { useGlobalModel } from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";

type OptionDsType = {
  label: string,
  value: string,
}
type labelsType = {
  [proppName: string]: string;
}
export const useBillSupplierModel = createModel(function () {
  const initSearchParam: IBillSearchParam = {};
  const initDataSource: IBillDetail[] = [];
  const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
  const { user: { shopCode } } = useGlobalModel();
  //查询条件
  const [searchParam, setSearchParam] = useState<IBillSearchParam>(initSearchParam);
  //列表数据源
  const [dataSource, setDataSource] = useState<IBillDetail[]>(initDataSource);
  //表格选中行Key值
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedData, setSelectedData] = useState<IBIllFields>();
  //列表数据源分页参数
  const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

  const [billSummaryData, setBillSummaryData] = useState<IBillSummary>({});
  const [writeoffDrawerVisible, setWriteoffDrawerVisible] = useState(false);

  const [orgDs, setOrgDs] = useState<ITreeData<IMdOrgDetail>[]>();
  const [beDs, setBeDs] = useState<OptionDsType[]>();
  const [appDs, setAppDs] = useState<OptionDsType[]>();
  const [payMethodDs, setPayMethodDs] = useState<OptionDsType[]>();
  const [payMethodLabels, setPayMethodLabels] = useState<labelsType>({});
  const [exportLoading, setExportLoading] = useState(false)


  const updatePgCfg = (updateParam: TablePaginationConfig) => {
    setPgCfg({ ...pgCfg, ...updateParam })
  }
  const updateSearchParam = (updateParam: IBillSearchParam) => {
    if (updateParam.time) {
      updateParam.billTimeRange = {
        startTime: updateParam.time[0] + ' 00:00:00',
        endTime: updateParam.time[1] + ' 23:59:59'
      }
    }
    setSearchParam({ ...searchParam, ...updateParam })
  }

  const resetSearchParam = () => {
    setSearchParam(initSearchParam);
    loadData(initPgCfg, {});
    setSelectedRowKeys([]);
  }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }

  const loadData = async (page: ISearchPage = initPgCfg, searchValue: IBillSearchParam = searchParam) => {
    const searchParams: IBillSearch = {
      ...searchValue,
      partnerTypeCode: UserTypeEnum.SUPPLIER,
      shopCode,
      page: {
        pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
        pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
      }
    }
    let { retData } = await billService.page(searchParams);
    let { retData: billSummaryRetData } = await billService.billSummary(searchParams);
    const { records, ...pg } = retData;
    setPgCfg(transPgToPagination(pg));
    setBillSummaryData(billSummaryRetData)
    setDataSource(records);
        clearSelectData();
  }

  //供应商账单导出
  const billSupplierExport = async () => {
    setExportLoading(true)
    try {
      const searchParams: IBillSearch = {
        ...searchParam,
        partnerTypeCode: UserTypeEnum.SUPPLIER,
        shopCode,
        page: {
          pageSize: -1,
          pageNum: 1
        }
      }
      let result = await billService.export(searchParams);
      convertRes2Blob(result);
      setExportLoading(false)
    } catch (error) {
      setExportLoading(false)
    }
  }

  return {
    /***field***/
    appDs,
    orgDs,
    beDs,
    payMethodDs,
    searchParam,
    dataSource,
    selectedRowKeys,
    pgCfg,
    selectedData,
    billSummaryData,
    writeoffDrawerVisible,
    payMethodLabels,
    exportLoading,
    /***method***/
    setOrgDs,
    setBeDs,
    setAppDs,
    setPayMethodDs,
    setPayMethodLabels,
    setDataSource,
    setSelectedRowKeys,
    resetSearchParam,
    updateSearchParam,
    loadData,
    updatePgCfg,
    setSelectedData,
    setWriteoffDrawerVisible,
    billSupplierExport
  }
});